'use client';

import { motion } from 'framer-motion';
import SectionTitle from '../ui/SectionTitle';

export default function About() {
  return (
    <section id="about" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
          >
            <SectionTitle
              eyebrow="À Propos"
              title="Christelle & La Canopée"
              centered={false}
            />
            <div className="space-y-4 font-sans text-forest/70 text-base leading-relaxed">
              <p>
                Passionnée par les bienfaits du massage et du bien-être holistique,
                Christelle a fondé La Canopée pour créer un espace de ressourcement
                véritable, loin de l&apos;agitation du quotidien.
              </p>
              <p>
                Formée aux techniques de massage suédois, californien et aux soins
                énergétiques, elle met son expertise et sa bienveillance au service de
                votre équilibre corps-esprit. Chaque séance est unique, pensée et
                adaptée à vos besoins du moment.
              </p>
              <p>
                La Canopée, c&apos;est plus qu&apos;un salon — c&apos;est un refuge de sérénité
                où vous pouvez vous reconnecter à vous-même.
              </p>
            </div>
            <a
              href="#booking"
              className="mt-8 inline-flex items-center gap-2 bg-forest text-cream-100 font-sans text-sm px-7 py-3.5 rounded-full hover:bg-forest-dark transition-colors tracking-wide"
            >
              Prendre rendez-vous
            </a>
          </motion.div>

          {/* Photo placeholder */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1], delay: 0.1 }}
            className="relative"
          >
            {/* Main photo placeholder */}
            <div
              className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden"
              style={{
                background:
                  'linear-gradient(135deg, #c5dbc8 0%, #8db894 40%, #5a8a62 100%)',
              }}
            >
              <div className="absolute inset-0 flex items-center justify-center">
                <p className="font-sans text-cream-50/60 text-sm tracking-widest uppercase">
                  Photo à venir
                </p>
              </div>
            </div>

            {/* Floating accent card */}
            <div className="absolute -bottom-6 -left-6 bg-cream-100 rounded-2xl p-5 shadow-lg border border-cream-200 max-w-[180px]">
              <p className="font-serif text-3xl text-forest-dark leading-none mb-1">
                +5
              </p>
              <p className="font-sans text-xs text-forest/60 leading-snug">
                années d&apos;expertise en soins bien-être
              </p>
            </div>

            {/* Decorative dot pattern */}
            <div
              className="absolute -top-6 -right-6 w-24 h-24 opacity-30"
              style={{
                backgroundImage:
                  'radial-gradient(circle, #3a5a40 1px, transparent 1px)',
                backgroundSize: '8px 8px',
              }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
